const AUTH_STORAGE_KEY = "brew-rides-admin-auth"

export function getStoredAdminAuth(): string | null {
  if (typeof sessionStorage === "undefined") return null
  return sessionStorage.getItem(AUTH_STORAGE_KEY)
}

export function setStoredAdminAuth(header: string): void {
  sessionStorage.setItem(AUTH_STORAGE_KEY, header)
}

export function clearStoredAdminAuth(): void {
  sessionStorage.removeItem(AUTH_STORAGE_KEY)
}

export async function promptForAdminAuth(): Promise<string | null> {
  const password = window.prompt("Admin password:")
  if (!password) return null
  const encoded = btoa(`admin:${password}`)
  return `Basic ${encoded}`
}
